<div class="header_css">
    <app-header-nav></app-header-nav>
</div>
<div class="view_page">
    <router-outlet></router-outlet>
</div>
<div class="footer">
    <app-footer></app-footer>
</div>